module.exports = __webpack_public_path__ + "img/addpracticestaff.923cf6a7.png";